
const DeleteConfirmationTypeEnum = {
    DELETE : 'DELETE',
    STATUS :'STATUS'
}

Object.freeze(DeleteConfirmationTypeEnum);

export default DeleteConfirmationTypeEnum;